/**
 * iwoUploadFilesModule 文件上传模块
 * author: Qian.qianchen 2019-06-29
 */
'use strict';
angular.module('iwoUploadFilesModule', []).controller('iwoUploadFilesCtrl', [
    '$scope',
    '$q',
    'trsHttpService',
    '$modalInstance',
    '$filter',
    'modalDialog',
    'Upload',
    function($scope, $q, trsHttpService, $modalInstance, $filter, modalDialog, Upload) {
        initStatus();

        function initStatus() {
            $scope.status = {};
            $scope.data = {};
        }
        $scope.selectFiles = function(files, file, newFiles) {
            var finishFiles = [];
            let uploadFilesLength = files.length;
            for (var i in files) {
                var file_ = files[i];
                if (parseInt(file_.size) / 1024 / 1024 > 50) {
                    modalDialog.alertType('', '文件太大，不得大于50MB!', 'warning', false, () => {});
                    files.splice(i, 1);
                    uploadFilesLength--;
                } else {
                    $scope.loadingPromise = uploadFiles(file_, uploadFilesLength).then(function(file) {
                        finishFiles.push(file);
                        if (finishFiles.length === uploadFilesLength) {
                            modalDialog.alertType('', '上传成功', 'success', false, () => {
                                $modalInstance.close(finishFiles);
                            });
                            $scope.data.files = [];
                        }
                    });
                }
            }

            /**
             * [uploadFiles description]上传接口
             *
             * @param   {[type]}  file_   [file_ description]
             * @param   {[type]}  length  [length description]
             *
             * @return  {[type]}          [return description]
             */
            function uploadFiles(file_, length) {
                var deffer = $q.defer();
                var file = {};
                Upload.upload({
                    url: '/message/file/upload',
                    data: {
                        file: file_,
                    },
                }).then(
                    function(resp) {
                        if (resp.issucess == 'false') {
                            modalDialog.alertType('', resp.msg, 'error', false);
                            length--;
                            defer.reject();
                        } else {
                            file.FileSize = resp.data.data.FileSize;
                            file.FileDesc = resp.data.data.FileDesc;
                            file.FileName = resp.data.data.FileName;
                            deffer.resolve(file);
                        }
                    },
                    function(resp) {
                        if (resp.status == '413') {
                            file.error = '文件太大，不得大于50MB!';
                        } else {
                            file.error = '未知错误!';
                        }
                        deffer.resolve(file);
                    },
                    function(evt) {
                        file_.FILEINFO = '上传中';
                    }
                );
                return deffer.promise;
            }
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
